import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import AutoBindComponent from "../../common/AutoBindComponent";

import * as vrLayoutActions from "../../../actions/voortgangsrapportLayoutActions";
import * as beadActions from "../../../actions/beadActions";
import * as ajaxActions from "../../../actions/ajaxCounterActions";
import * as exceptionActions from "../../../actions/exceptionActions";
import * as types from "../../../constants/ComponentConstants";
import * as domainConstants from "../../../constants/DomainConstants";
import voortgangsrapportVerantwoordingApi from "../../../api/voortgangsrapportVerantwoordingApi";
import VRVerantwoordingForm from "./VRVerantwoordingForm";
import VRVerantwoordingPageHelper from "./VRVerantwoordingPageHelper";
import unsavedDataDialogHandler from "../../common/UnsavedDataDialogHandler";
import * as documentActions from "../../../actions/documentActions";
import { uploadOneVoortgangsrapportFile, deleteOneVoortgangsrapportFile } from "../../common/DownloadUploadFilesHelper";

import showToastr, { showToastrError, showToastrInfo, showToastrSuccess } from "../../../util/toastr.js";

import EasterEggHandler from "../../common/EasterEggHandler";
import * as pageConstants from "../../../constants/EasterEggConstants";

class VRVerantwoordingPage extends AutoBindComponent {
	constructor(props, context) {
		super(props, context);

		this.state = {
			vrVerantwoording: {},
			errors: {},
			hasUnsavedChanges: false,
			sjablonen: []
		};

		this.pageHelper = new VRVerantwoordingPageHelper(this);
		this.easterEggHandler = new EasterEggHandler(this, pageConstants.VOORTGANGSRAPPORT_VERANTWOORDING);
	}

	componentDidMount() {
		this.easterEggHandler.bind();
	}
	componentWillUnmount() {
		this.easterEggHandler.unbind();
	}

	componentWillReceiveProps(nextProps) {
		this.pageHelper.update(nextProps);
	}

	componentWillMount() {
		this.pageHelper.init();
	}

	handleOnChange(event) {
		this.pageHelper.onChange(event);
	}

	handleOnSave() {
		this.pageHelper.onSave();
	}

	handleOnDropFiles(component, files) {
		this.pageHelper.onDropFiles(component, files);
	}

	handleOnDeleteFile(component, fileName) {
		this.pageHelper.onDeleteFile(component, fileName);
	}

	isReadyToRender() {
		return !!this.state.vrVerantwoording
			&& this.state.vrVerantwoording.id
			&& this.props.refGemeenten;
	}

	render() {
		if (!this.isReadyToRender()) {
			return null;
		}

		const vrVerantwoording = this.state.vrVerantwoording;

		return (
			<VRVerantwoordingForm
				vrVerantwoording={vrVerantwoording}
				disabled={this.props.disableInput} //todo add new property from crm
				errors={this.state.errors}
				color={types.COLOR_PINK_LIGHT}
				onChange={this.handleOnChange}
				onSave={this.handleOnSave}
				projectId={this.props.vrProjectId}

				fileTypes={this.props.fileTypes}
				sjablonen={this.state.sjablonen}
				documenten={this.state.documenten}
				fileSessionStarted={this.state.fileSessionStarted}
				onDropFiles={this.handleOnDropFiles}
				onDeleteFile={this.handleOnDeleteFile}
			/>
		);
	}
}

VRVerantwoordingPage.propTypes = {
	loadLayout: PropTypes.func,
	refGemeenten: PropTypes.object.isRequired,
	vrProjectId: PropTypes.string
};

function mapStateToProps(state, ownProps) {
	const vrProjectId = ownProps.params.vrProjectId;
	const isNew = ownProps.route.params.isNew;
	const refGemeenten = state.referentie.gemeenten || {};
	const disableInput = state.layout.disableInputComponents;
	const vrLoaded = state.voortgangsrapportLoaded;

	return {
		vrProjectId,
		isNew,
		refGemeenten,
		fileTypes: state.settings.fileTypes,
		disableInput,
		vrLoaded
	};
}
function mapDispatchToProps(dispatch) {
	return {
		loadLayout: bindActionCreators(vrLayoutActions.loadVRPageLayout, dispatch),
		ajaxStarted: bindActionCreators(ajaxActions.started, dispatch),
		ajaxEnded: bindActionCreators(ajaxActions.ended, dispatch),
		ajaxFailed: bindActionCreators(ajaxActions.failed, dispatch),
		throwException: bindActionCreators(exceptionActions.throwException, dispatch),
		beadsLoaded: bindActionCreators(beadActions.voortgangsrapportBeadsLoaded, dispatch),
		getSjablonen: bindActionCreators(documentActions.getVoortgangsrapportSjablonen, dispatch),
		uploadDocument: bindActionCreators(documentActions.uploadVoortgangsrapportDocument, dispatch),
		deleteDocument: bindActionCreators(documentActions.deleteVoortgangsrapportDocument, dispatch),
		startFileSession: bindActionCreators(documentActions.startVoortgangsrapportFileSession, dispatch),
		endFileSession: bindActionCreators(documentActions.endVoortgangsrapportFileSession, dispatch),
		getContent: bindActionCreators(documentActions.getVoortgangsrapportContent, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(unsavedDataDialogHandler(VRVerantwoordingPage));